export default __webpack_public_path__ + "static/media/pencil-icon.cc8c21b0.svg";